export const getCategories = '/api/v1/faq_categories';
export const getFeaturedFaqs = '/api/v1/faqs?featured';